export default "__VITE_ASSET__CTPHrPfR__"